import React from 'react';
import LightingIcon from 'components/Icons/LightingIcon';
import styles from './HighlightInfo.module.css';

function HighlightInfo({ text }: { text: string }) {
    return (
        <div className={styles.highlightInfo}>
            <LightingIcon />
            <p>{text}</p>
        </div>
    );
}

export default HighlightInfo;
